import React from 'react';
import { useQuery, useMutation } from '@apollo/client/react';
import { Link } from 'react-router-dom';
import { TEAMS_QUERY } from '../graphql/queries';
import { DELETE_TEAM } from '../graphql/mutations';
import DataTable from '../components/DataTable';
import EmptyState from '../components/EmptyState';
import QueryError from '../components/QueryError';
import M3LinearProgress from '../components/M3Progress';
import TableActions from '../components/TableActions';

export default function TeamsPage() {
  const { data, loading, error } = useQuery(TEAMS_QUERY);
  const [deleteTeam] = useMutation(DELETE_TEAM, {
    refetchQueries: [{ query: TEAMS_QUERY }],
    awaitRefetchQueries: true
  });

  const columns = [
    { key: 'name', title: 'Name' },
    { key: 'membersCount', title: 'Members', render: (v) => v || 0 },
    { key: 'publicationsCount', title: 'Publications', render: (v) => v || 0 },
    { key: 'createdAt', title: 'Created', render: (v) => new Date(v).toLocaleDateString() }
  ];

  if (error)
    return (
      <div className="page-content">
        <QueryError error={error} onRetry={() => window.location.reload()} />
      </div>
    );

  if (loading)
    return (
      <div className="page-content">
        <M3LinearProgress indeterminate />
      </div>
    );

  if (!data?.teams?.length) {
    return (
      <div className="page-content">
        <EmptyState
          icon="groups"
          title="No Teams"
          message="No teams have been created yet."
          action={
            <Link to="/teams/new" className="btn btn-primary mt-3">
              Create Team
            </Link>
          }
        />
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Teams</h1>
        <Link to="/teams/new" className="btn btn-primary">
          <span className="material-symbols-rounded">add</span>
          Create Team
        </Link>
      </div>
      <DataTable
        columns={columns}
        data={data.teams}
        loading={loading}
        rowKey="id"
        emptyMessage="No teams found"
        actions={(team) => (
          <TableActions
            items={[
              { icon: 'visibility', label: 'View', to: `/teams/${team.id}` },
              { icon: 'edit', label: 'Edit', to: `/teams/${team.id}/edit` },
              {
                icon: 'delete',
                label: 'Delete',
                danger: true,
                onClick: () => {
                  if (window.confirm(`Delete "${team.name}"? This cannot be undone.`)) {
                    deleteTeam({ variables: { input: { id: team.id } } });
                  }
                }
              }
            ]}
          />
        )}
      />
    </div>
  );
}
